import React, { useContext, useState, createContext } from 'react'
import useUserPref from '../../hooks/useUserPref'
import useChips from './useChips'
import { isBoolean } from '../../utils/empty'

export const ReportsContext = createContext({})

export default function ReportsProvider({ children }) {
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [printButtonDisabled, setPrintButtonDisabled] = useState(false)
  const [print, setPrint] = useState(false)
  const [selectedUnit, setSelectedUnit] = useState()
  const [printFormat, setPrintFormat] = useState('letter')
  // these options are used to determine the stats request options

  const {
    loading: chipSelectionLoading,
    userPreference: chipSelection,
    setUserPreference: setChipSelection,
  } = useUserPref('reports.ChipSelection')

  const { loading: customDatesLoading, setUserPreference: setCustomDates, userPreference: customDates } = useUserPref(
    'reports.CustomDates'
  )

  // usefull for testing when you want the custom date to be reset
  // useEffect(() => {
  //   setTimeout(() => {
  //     setCustomDates({})
  //   }, 1000)
  // }, [])

  const { chips } = useChips({ selectedChipName: chipSelection, customDates })

  return (
    <ReportsContext.Provider
      value={{
        chips,
        chipSelection,
        chipSelectionLoading: isBoolean(chipSelectionLoading) && chipSelectionLoading,
        customDates,
        customDatesLoading: isBoolean(customDatesLoading) && customDatesLoading,
        endDate,
        printButtonDisabled,
        print,
        printFormat,
        selectedUnit,
        setChipSelection,
        setCustomDates,
        setPrintFormat,
        setEndDate,
        setPrint,
        setPrintButtonDisabled,
        setSelectedUnit,
        setStartDate,
        startDate,
      }}
    >
      {children}
    </ReportsContext.Provider>
  )
}

export const useReports = () => useContext(ReportsContext)
